//#region IMPORTS
import { MetaData } from "../../models/pagination";
import { ReactNode } from "react";
import LoadingOverlay from "../loading/LoadingOverlay";
import LoadingSpinner from "../loading/LoadingSpinner";
import PaginationBar from "../paginationBar/PaginationBar";
//#endregion

//#region INTERFACE
interface Props {
  onPageChangeHandler?: (page: number) => void;
  clientPaginate?: boolean;
  itemsLoaded: boolean;
  children: ReactNode;
  metaData?: MetaData;
  pageType?: string;
  header: ReactNode;
  hide?: boolean;
}
//#endregion

export default function MainTable({
  onPageChangeHandler,
  clientPaginate = false,
  itemsLoaded,
  children,
  metaData,
  pageType = "items",
  header,
  hide = false,
}: Props) {
  if (hide) {
    return itemsLoaded ? (
      <p className="py-16 text-center text-gray-500">No {pageType} found.</p>
    ) : (
      <LoadingSpinner />
    );
  }
  return (
    <div className="relative">
      {!itemsLoaded && <LoadingOverlay />}
      <table className="min-w-full divide-y divide-gray-300">
        {header}
        <tbody className="bg-white">{children}</tbody>
      </table>
      {clientPaginate ? null : (
        <PaginationBar
          metaData={metaData}
          onPageChange={(page: number) =>
            onPageChangeHandler && onPageChangeHandler(page)
          }
          pageType={pageType}
          hide={!metaData}
        />
      )}
    </div>
  );
}
